'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiAdjustBrightness = function TiAdjustBrightness(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 11.6l1.7-4.9c0.1-0.4 0.1-0.8 0-1.2-0.3-0.9-1.3-1.4-2.3-1.1-0.9 0.3-1.4 1.3-1.1 2.3l1.7 4.9z m-13.3 6.7c-0.4-0.1-0.8-0.1-1.2 0-0.9 0.3-1.4 1.3-1.1 2.3 0.3 0.9 1.3 1.4 2.3 1.1l4.9-1.7-4.9-1.7z m13.3 10.1l-1.7 4.9c-0.1 0.4-0.1 0.8 0 1.2 0.3 0.9 1.3 1.4 2.3 1.1 0.9-0.3 1.4-1.3 1.1-2.3l-1.7-4.9z m15.6-9c-0.3-0.9-1.3-1.4-2.3-1.1l-4.9 1.7 4.9 1.7c0.4 0.1 0.8 0.1 1.2 0 0.9-0.3 1.4-1.4 1.1-2.3z m-26.2-7.6l4.6 2.2-2.2-4.6c-0.2-0.3-0.5-0.6-0.9-0.8-0.8-0.4-1.9-0.1-2.3 0.8-0.4 0.9-0.1 1.9 0.8 2.4z m-0.8 17.3c-0.4 0.8-0.1 1.9 0.8 2.3 0.9 0.4 1.9 0.1 2.3-0.8l2.3-4.6-4.6 2.3c-0.3 0.1-0.6 0.4-0.8 0.8z m22-0.9l-4.6-2.2 2.2 4.6c0.2 0.3 0.5 0.6 0.9 0.8 0.8 0.4 1.9 0.1 2.3-0.8s0.1-1.9-0.8-2.4z m0.8-17.3c0.4-0.8 0.1-1.9-0.8-2.3-0.9-0.4-1.9-0.1-2.4 0.8l-2.2 4.6 4.6-2.3c0.3-0.1 0.6-0.4 0.8-0.8z m-11.4 1.6c-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5-3.4-7.5-7.5-7.5z' })
        )
    );
};

exports.default = TiAdjustBrightness;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/adjust-brightness.js
// module id = 1938
// module chunks = 0